import { useOpeningHours } from '@/lib/queries/useOpeningHours'

export function useBookingOpeningHours() {
  return useOpeningHours('booking')
}
